import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { TextBlockPartnerComponent } from './text-block-partner.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';

@NgModule({
  imports: [
    JssModule.forChild(TextBlockPartnerComponent),
    AppComponentsSharedModule
  ],
  declarations: [
    TextBlockPartnerComponent
  ],
})
export class TextBlockPartnerModule { }
